import { SerializedNodes } from "@craftjs/core";

export const EditableStep2Page: SerializedNodes = {
    ROOT: {
        type: { resolvedName: "Page" },
        isCanvas: true,
        props: { title: "Untitled Page", language: "int-en", pageType: "Step2" },
        displayName: "Page",
        custom: { displayName: "Page" },
        hidden: false,
        nodes: ["dsCVJyOHPj", "cQYjvL5VWy", "as3Ks2b4d"],
        linkedNodes: {},
        parent: null,
    },
    dsCVJyOHPj: {
        type: { resolvedName: "StepHeader" },
        isCanvas: true,
        props: { step: "2" },
        displayName: "Header",
        custom: { canDelete: false, displayName: "Header Section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
    cQYjvL5VWy: {
        type: { resolvedName: "Step2Content" },
        isCanvas: true,
        props: {},
        displayName: "Content",
        custom: { canDelete: false, displayName: "Content section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
    as3Ks2b4d: {
        type: { resolvedName: "StepSpotlight" },
        isCanvas: true,
        props: { nextStep: "3" },
        displayName: "Spotlight",
        custom: { canDelete: false, displayName: "Spotlight Section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
};
